import React, {Component, Fragment} from 'react';
import {connect} from "react-redux";
import PropTypes from "prop-types";
import css from 'scss';

class QuestionPoint extends Component {
    constructor(props) {
        super(props);

        this.question = props.test[props.area].answers[props.code];

        this.handleClick = this.handleClick.bind(this);
    }

    getColor() {
        let color = 'none';

        if (this.question && this.question.first) color = css['$color-white'];
        if (this.question && !this.question.first) color = css['$color-yellow'];

        return color;
    }

    handleClick() {
        this.props.dispatch({ type: 'SHOW_SUMMARY_QUESTION', question: this.props.code });
    }

    render () {
        return (
            <g id={this.props.code} transform={`translate(${this.props.x}, ${this.props.y})`} onClick={this.handleClick}>
                <circle cx="23" cy="23" r="22"
                        fill={!this.question ? css[`$color-black`] : this.getColor()}
                        stroke={!this.question ? css['$color-yellow'] : 'none'}
                        className="single-point"
                />
                {this.question &&
                    <Fragment>
                        <clipPath id={`path_${this.props.code}`}>
                            <rect x="1" y="1" width={44 * this.props.percent / 100} height="44"/>
                        </clipPath>
                        <circle cx="23" cy="23" r="22" fill={this.question.first ? css['$color-yellow'] : css['$color-white']} clipPath={`url(#path_${this.props.code})`}/>
                    </Fragment>
                }
            </g>
        );
    }
};

const mapStateToProps = (state) => {
    return {
        test: state.test,
    }
};

export default connect(mapStateToProps)(QuestionPoint);


QuestionPoint.defaultProps = {
    code: '',
    area: '',
    x: 0,
    y: 0,
    percent: 50,
};

QuestionPoint.propTypes = {
    area: PropTypes.string,
    code: PropTypes.string,
    x: PropTypes.number,
    y: PropTypes.number,
    percent: PropTypes.number,
};


// WEBPACK FOOTER //
// ./sources/js/components/Summary/graph/QuestionPoint.js